module.exports = {"PLP":{"productKey":"PLP","url":"/personalised-learning/","ganame":"Personalised Learning"},"SPL":{"productKey":"SPL","url":"/self-learning/","ganame":"Self-Paced Lessons"},"EXAM_PREP_CBSE":{"productKey":"EXAM_PREP_CBSE","url":"/cbse-exam/","ganame":"CBSE Exam Prep"},"TCHR_SPL":{"productKey":"TCHR_SPL","url":"/self-learning/","ganame":"Self-Paced Lessons for Teachers"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/ProductConfig.json
// module id = 99
// module chunks = 0